import { render, staticRenderFns } from "./AccLevyRates.vue?vue&type=template&id=28db07fc&scoped=true&"
import script from "./AccLevyRates.vue?vue&type=script&lang=js&"
export * from "./AccLevyRates.vue?vue&type=script&lang=js&"
import style0 from "./AccLevyRates.vue?vue&type=style&index=0&id=28db07fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28db07fc",
  null
  
)

export default component.exports